// Shared constants + helpers for the workflow feature so the same magic
// strings aren't repeated across the sidebar, the chat header, and the
// detail page.

// sessionStorage key the sidebar uses to hand a workflow invocation prompt
// to the chat page across navigation.
export const SESSION_KEY_PENDING_PROMPT = "liando.pendingPrompt";

// Custom DOM event name fired when a workflow is created / renamed /
// deleted; AppShell listens so its sidebar list refreshes without a route
// change.
export const EVENT_WORKFLOWS_CHANGED = "liando:workflows-changed";

// Custom DOM event name fired when conversations are created / renamed /
// archived or when a chat turn appends messages. AppShell listens so its
// sidebar list does not keep stale timestamps while the route stays the same.
export const EVENT_CONVERSATIONS_CHANGED = "liando:conversations-changed";

// Custom DOM event fired when update_land_ruleset stages a pending edit; Chat.tsx
// listens and opens the admin confirmation dialog (the edit is written only on
// explicit admin confirm, never by the model alone).
export const EVENT_PENDING_RULESET_EDIT = "liando:pending-ruleset-edit";

// How many key_columns to render in the workflow detail page's input-file
// summary before truncating to "…".
export const KEY_COLUMNS_PREVIEW = 8;

// Build the prompt the chat page pre-fills when the user clicks "运行"
// on a workflow. Intentionally drops the user-controlled name to avoid any
// prompt-injection vector — the agent's run_workflow tool returns the
// name in its tool result so the agent can refer to it when talking back.
export function buildWorkflowRunPrompt(workflowId: string): string {
  return `请用工作流 (workflow_id=${workflowId}) 处理我上传的文件。`;
}
